/**
 * Utilitaires de formatage des prix
 * Arrondit les prix au franc/euro le plus proche (sans centimes)
 */

/**
 * Formate un prix en arrondissant au franc le plus proche
 * @param {number} price - Le prix à formater
 * @returns {string} Le prix arrondi sans centimes
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined || isNaN(price)) {
    return '0';
  }
  return Math.round(price).toString();
};

/**
 * Formate un prix avec le symbole € 
 * @param {number} price - Le prix à formater
 * @returns {string} Le prix arrondi avec €
 */
export const formatPriceWithCurrency = (price) => {
  return `${formatPrice(price)} €`;
};

/**
 * Formate un prix unitaire (pour affichage dans les détails)
 * Garde les centimes pour les prix unitaires des options (sanglons, lests)
 * @param {number} price - Le prix unitaire
 * @returns {string} Le prix avec 2 décimales
 */
export const formatUnitPrice = (price) => {
  if (price === null || price === undefined || isNaN(price)) {
    return '0.00';
  }
  return price.toFixed(2);
};

export default formatPrice;
